import axios from 'axios'
import router from '@/router'
import { Toast } from 'vant';
import { toapp } from "@/utils/utils";

// 获取协议
const getProtocol = () => {
  return window.location.protocol
}

// 获取请求域名
const getBaseUrl = () => {
  //console.log('process.env.VUE_APP_URL：', process.env.VUE_APP_URL)
  return `${getProtocol()}//${process.env.VUE_APP_URL}/trove`
}

// axios 全局配置
// axios.defaults.timeout = 10000
// axios.defaults.baseURL = getBaseUrl()
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const instance = axios.create({
  baseURL: getBaseUrl(),
  timeout: 10000,
});


// request 请求拦截器
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
	config.headers['os'] = localStorage.getItem('os') || 0 //app内嵌 为3
    if (token) config.headers['Authorization'] = token.indexOf('Bearer')>-1?token:`Bearer ${token}`
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// response 响应拦截器
axios.interceptors.response.use(({ data }) => {
  const status = data.code
  // 调用失败
  if (status === 400 || status === 401) {
    
    // 登录失效
    if (status === 401) {
      // Toast.fail(data.msg)

      const redirect_url = router.history.current.fullPath
      toapp('6')
    //   router.push({
    //     name: 'invitation_login',
    //     query: {
    //         redirect_url,
    //     },
    //   })

    }
    return Promise.reject(data)
  }
  
  

  // 调用成功
  if (status === 200 || status === 201) {
    return data.data
  }else if(status!=401){
	  Toast.fail(data.msg)
	  return Promise.reject(data)
  }

  return Promise.reject(data)
}, err => {
  Toast.clear()
  Toast.fail('网络请求超时')
  if (err.response) {
    switch (err.response.status) {
      case 500:
       
        break
      default:
    }
  }

  return Promise.reject(err)
})


// 设置 token
export const setToken = (token) => {
  axios.defaults.headers['Authorization'] = token
}

export default axios